export default "__VITE_ASSET__S1u6Z$_7__"